import { Injectable } from '@angular/core';

export interface StepperProject {
  /** Unique backend identifier for the project being processed by the stepper. */
  projectId: number;
  /** Human-readable project name used in titles and persisted stepper state. */
  projectName: string;
}

export interface PersistedSession {
  project: StepperProject;
  roomMaterialSelections: Record<string, string>;
  roomMaterialRates: Record<string, number>;
  roomMaterialQuantities: Record<string, number>;
  contractorComments: string;
}

@Injectable({ providedIn: 'root' })
export class StepperSessionService {
  private readonly KEY = 'ctp_stepper_v1';
  private timer: ReturnType<typeof setTimeout> | null = null;

  save(session: PersistedSession): void {
    if (this.timer !== null) clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      sessionStorage.setItem(this.KEY, JSON.stringify(session));
      this.timer = null;
    }, 500);
  }

  load(): PersistedSession | null {
    try {
      const raw = sessionStorage.getItem(this.KEY);
      if (!raw) return null;
      const session: PersistedSession = JSON.parse(raw);
      if (!session?.project?.projectId) { this.clear(); return null; }
      return session;
    } catch {
      this.clear();
      return null;
    }
  }

  clear(): void {
    sessionStorage.removeItem(this.KEY);
  }
}
